<!--
    ____            _           _____
   / ___|    ___   | |   ___   |_   _|   ___    _ __    _   _
   \___ \   / _ \  | |  / _ \    | |    / _ \  | '_ \  | | | |
    ___) | | (_) | | | | (_) |   | |   | (_) | | | | | | |_| |
   |____/   \___/  |_|  \___/    |_|    \___/  |_| |_|  \__, |
  Created by Antonio Solo                               |___/
  Project & copyright: NSB.SU
-->

<template>
    <div v-if="room_id && is_room_loaded">
        <b-modal
            v-model="show_modal_local"
            :title="room.title"
            class="modal-primary"
            size="xl"
            ok-variant="primary"
            @hide.prevent
            @ok="handleOk"
            @cancel="handleCancel"
            @close="handleCancel"
            ref="my-modal"
        >

            <b-tabs nav-wrapper-class="w-40">
                <b-tab active>
                    <template slot="title"><i class="icon-calculator"></i> Общие данные</template>

                    <div class="row">

                        <div class="col col-12 col-lg-6">
                            <b-form-group
                                label="Доступность номера"
                            >
                                <div class="custom-control custom-checkbox custom-control-inline">
                                    <input
                                        type="checkbox"
                                        class="custom-control-input"
                                        id="enabled"
                                        value="1"
                                        v-model="_enabled">
                                    <label class="custom-control-label" for="enabled">номер доступен для заказов</label>
                                </div>
                            </b-form-group>
                        </div>

                        <div class="col col-12 col-lg-6">
                            <b-form-group
                                label="Доступность номера"
                            >
                                <div class="custom-control custom-checkbox custom-control-inline">
                                    <input
                                        type="checkbox"
                                        class="custom-control-input"
                                        id="allow_book_per_place"
                                        v-model="room.allow_book_per_place">
                                    <label class="custom-control-label" for="allow_book_per_place">места можно бронировать по-одному</label>
                                </div>
                            </b-form-group>
                        </div>



                        <div class="col col-12 col-lg-6">
                            <b-form-group
                                label="Фейковая квота"
                            >
                                <v-select
                                    :options="faker"
                                    :plain="true"
                                    v-model.number="room.faker"
                                    label="label"
                                    :reduce="x=>x.id"
                                    placeholder="Выберите тип фейка"
                                ></v-select>
                            </b-form-group>
                        </div>

                        <div class="col col-12">
                            <b-form-group
                                label="Наименование номера"
                                description="должен быть только текст, не более 200 символов, уже введено titleLength "
                                :state="validateState('title')"
                                :invalid-feedback="veeErrors.first('title')"
                            >
                                <input
                                    class="form-control"
                                    type="text"
                                    v-model="room.title"
                                    v-validate="{ required:true,max:200 }"
                                    name="title"
                                    data-vv-as="'Наименование номера'"
                                >
                            </b-form-group>
                        </div>

                        <div class="col col-12 col-lg-6" v-if="isExternalBooker(hotel)">
                            <b-form-group
                                :label="'Номер в системе бронирования #'+booker_room_id"
                                :description="'Объект бронируется через ' + externalBookerName(hotel)"
                            >
                                <v-select
                                    :options="booker_rooms"
                                    :plain="true"
                                    v-model.number="booker_room_id"
                                    label="title"
                                    :reduce="x=>x.id"
                                    placeholder="Выберите категорию номеров"
                                ></v-select>
                            </b-form-group>
                        </div>

                        <div class="col col-12 col-lg-6" v-if="isExternalBooker(hotel) && booker_room_id">
                            <b-form-group
                                :label="'Копирование данных ' + externalBookerName(hotel)"
                                description="будут скопированы наименование, краткая информация, количество мест"
                            >
                                <button type="button" class="btn btn-primary" @click="copyExternRoomData">скопировать данные объекта</button>
                            </b-form-group>
                        </div>
                    </div>
                    <div class="row">


                        <div class="col col-4">
                            <b-form-group
                                label="Количество основных мест"
                                :invalid-feedback="veeErrors.first('places_main')"
                            >
                                <input
                                    class="form-control"
                                    type="text"
                                    v-model="room.places_main"
                                    v-validate="{ integer:true,required:true,min_value:1  }"
                                    name="places_main"
                                    data-vv-as="'Количество основных мест'"
                                >
                            </b-form-group>
                        </div>


                        <div class="col col-4">
                            <b-form-group
                                label="Количество дополнительных мест"
                                :invalid-feedback="veeErrors.first('places_additionally')"
                            >
                                <input
                                    class="form-control"
                                    type="text"
                                    v-model="room.places_additionally"
                                    v-validate="{ integer:true,required:true,min_value:0  }"
                                    name="places_additionally"
                                    data-vv-as="'Количество дополнительных мест'">
                            </b-form-group>
                        </div>

                        <div class="col-4">
                            <b-form-group
                                label="Количество комнат в номере"
                                :invalid-feedback="veeErrors.first('rooms')"
                            >
                                <input
                                    class="form-control"
                                    type="text"
                                    v-model="room.rooms"
                                    v-validate="{ integer:true,required:true,min_value:1  }"
                                    name="rooms"
                                    data-vv-as="'Количество комнат в номере'">
                            </b-form-group>
                        </div>


                        <div class="col col-4">
                            <b-form-group
                                label="Категория"
                                :invalid-feedback="veeErrors.first('category')"
                            >
                                <input
                                    class="form-control"
                                    type="text"
                                    v-model="room.category"
                                    v-validate="{ max:100 }"
                                    name="category"
                                    data-vv-as="'Категория'"
                                >
                            </b-form-group>
                        </div>

                        <div class="col col-4">
                            <b-form-group
                                label="Корпус"
                                :invalid-feedback="veeErrors.first('housing')"
                            >
                                <input
                                    class="form-control"
                                    type="text"
                                    v-model="room.housing"
                                    v-validate="{ max:100  }"
                                    name="housing"
                                    data-vv-as="'Корпус'"
                                >
                            </b-form-group>
                        </div>
                        <div class="col col-4">
                            <b-form-group
                                label="Количество номеров этого типа"
                                :invalid-feedback="veeErrors.first('count_numbers')"
                            >
                                <input
                                    class="form-control"
                                    type="text"
                                    v-model="room.count_numbers"
                                    v-validate="{ integer:true,required:true,min_value:0  }"
                                    name="count_numbers"
                                    data-vv-as="'Количество номеров этого типа'"
                                >
                            </b-form-group>
                        </div>


                        <div class="col col-12">
                            <b-form-group
                                label="Краткая информация публичного дополнения"
                                description="можно использовать HTML-тэги"
                            >
                                <textarea
                                    class="form-control"
                                    v-model="room.information_public"
                                    placeholder="введите несколько строчек"
                                ></textarea>
                            </b-form-group>
                        </div>

                        <div class="col col-12">
                            <b-form-group
                                label="Краткая информация для внутреннего использования"
                                description="можно использовать HTML-тэги"
                            >
                                <textarea
                                    class="form-control"
                                    v-model="room.information_private"
                                    placeholder="введите несколько строчек"
                                ></textarea>
                            </b-form-group>
                        </div>

                        <div class="col">
                            <b-form-group
                                label="Полное описание номера"
                                description="можно использовать HTML-тэги"
                            >
                                <textarea
                                    class="form-control"
                                    v-model="room.content_html"
                                    placeholder="введите несколько строчек"
                                ></textarea>
                            </b-form-group>
                        </div>
                    </div>
                </b-tab>

                <b-tab>
                    <template slot="title" ><i class="icon-pie-chart"></i> Фото</template>

                    <div class="table-responsive-sm">
                        <table aria-busy="false" class="table table-sm table-striped table-hover table-bordered table-sm ">
                            <thead role="rowgroup" class="">
                            <tr role="row">
                                <th role="columnheader" scope="col" aria-colindex="1" class="">Превью</th>
                                <th role="columnheader" scope="col" aria-colindex="2" class="">Подпись</th>
                                <th role="columnheader" scope="col" aria-colindex="3" class="">Порядок</th>
                                <th role="columnheader" scope="col" aria-colindex="3" class="">Удалить</th>
                            </tr>
                            </thead>

                            <tr v-for="img in fRoomImages()">
                                <td><img :src="img.tn_url" alt="" style="width:80px;height:80px;"></td>
                                <td>
                                    <input v-model="img.title" class="form-control">
                                    <small>{{img.orig_fn}}</small>
                                </td>
                                <td>
                                    {{img.srt}}<br>
                                    <button class="btn btn-primary btn-sm" @click="onDown(img.id)">
                                        <i class="cui-chevron-bottom"></i>
                                    </button> &nbsp;
                                    <button class="btn btn-primary btn-sm" @click="onUp(img.id)">
                                        <i class="cui-chevron-top"></i>
                                    </button>
                                </td>
                                <td>
                                    <button class="btn btn-danger btn-sm" @click="onDeleteImage(img.id)">
                                        <i class="fa fa-times"></i>
                                    </button>
                                </td>
                            </tr>
                        </table>
                    </div>

                    <images-upload :saveurl="fRoomImagesSaveUrl()" :refname="'uploadr'+room.id" @goodtimetoreload="reloadImages"></images-upload>

                </b-tab>
            </b-tabs>


            <template slot="modal-footer" slot-scope="{ ok, cancel, close }">
                <b-button size="sm" variant="outline-secondary" @click="cancel()">
                    Закрыть
                </b-button>
                <b-button size="sm" variant="outline-success" @click="ok()">
                    Сохранить
                </b-button>
            </template>
        </b-modal>
    </div>
</template>


<script>
    import { functions } from '@/functions';
    import { functions_loaders } from '@/functions_loaders';
    import { functions_booker } from '@/functions_booker';
    import { functions_hotel } from '@/functions/hotel';
    import { functions_room } from '@/functions_room';
    import ImagesUpload from '@/components/ImagesUpload'

    export default {
        name: 'RoomEditDialog',
        mixins: [functions, functions_loaders, functions_room, functions_booker, functions_hotel],
        components: {
            ImagesUpload,
        },
        data: function () {
            return {
                faker: [
                    {id:0, label:'нет'},
                    {id:1, label:'всегда'},
                    {id:2, label:'при полном отсутствии'},
                ],
            };
        },
        model: {
            prop: "room_id",
            event: "hide"
        },
        props: {
            room_id: Number,
            hotel_prop: Object,
        },
        watch: {
        },
        methods: {
            handleCancel: function () {
                this.$emit("hide", 0);
            },
            handleOk: function () {
                let self = this;
                this.saveRoom(function(self){
                    let hotelRoom = self.findElementByID(self.hotel.rooms,self.room.id);
                    console.log('handleOk hotelRoom=',hotelRoom);
                    if (self.is(hotelRoom)) {
                        hotelRoom.title = self.room.title;
                        hotelRoom.prof_obj_rooms_id = self.room.prof_obj_rooms_id;
                    }
                    self.$emit("changed", self.room.id);
                    self.$emit("hide", 0);
                }, self);
            },
            imagesFiltrator: function(room_id) {
                return function(element) {
                    return element.room_id === room_id;
                }
            },
            fRoomImages: function() {
                return this.hotel.images.filter(this.imagesFiltrator(this.room.id)).sort((a, b) => (a.srt > b.srt) ? 1 : (a.srt === b.srt) ? ((a.srt > b.srt) ? 1 : -1) : -1 );
            },
            reloadImages: function() {
                this.$emit("reload_images");
            },
            fRoomImagesSaveUrl: function () {
                return this.apiurl('room/'+this.room.id+'/saveimg');
            },
            onUp: function (id) {
                let x = this.fRoomImages();
                let prev = null;
                let curr = null;
                for (let i=0; i<x.length; i++) {
                    prev=curr;
                    curr=x[i];
                    if (curr.id === id) {
                        if (prev!==null) {
                            console.log('replace ' + curr.id + ' ' + prev.id);
                            let t = prev.srt;
                            prev.srt = curr.srt;
                            curr.srt = t;
                            break;
                        }
                    }
                }
            },
            onDown: function (id) {
                let x = this.fRoomImages();
                let prev = null;
                let curr = null;
                for (let i=x.length-1; i>=0; i--) {
                    prev=curr;
                    curr=x[i];
                    if (curr.id === id) {
                        if (prev!==null) {
                            console.log('replace ' + curr.id + ' ' + prev.id);
                            let t = prev.srt;
                            prev.srt = curr.srt;
                            curr.srt = t;
                            break;
                        }
                    }
                }
            },
            onDeleteImage: function (id) {
                this.$emit("delete_image", id);
            },

            copyExternRoomData: function() {
                let extern_room = this.findElementByID(this.booker_rooms, this.booker_room_id);
                if (extern_room) {
                    this.room.title = extern_room.title;
                    this.room.places_main = extern_room.main_places;
                    this.room.places_additionally = extern_room.extra_places;
                    if (extern_room.info) {
                        this.information_public = extern_room.info;
                        this.room.content_html = extern_room.info;
                    }
                }
            }
        },
        computed: {
            show_modal_local: {
                get: function () {
                    return !!this.room_id
                },
                set: function (newValue) {}
            },
            hotelImageFields: function() {
                return ['url', 'srt', 'title', 'orig_fn'];
            },

            _enabled: {
                get: function () {
                    return !this.room.m_disabled;
                },
                set: function (v) {
                    this.room.m_disabled = !v;
                },
            }
        },
        created: function() {
            this.hotel = this.hotel_prop;
            this.loadRoom(this.room_id);
            if (this.isExternalBooker(this.hotel)) {
                this.loadBookerRooms(this.booker_id, this.booker_hotel_id);
            }
        },
    }
</script>


